export const updateStyle = (styleName, design) => {
    const styleElement = document.createElement("style");
    if (styleName == "purple") {
        styleElement.innerHTML = `
      :root {
        --color-fourth-transparent: hsla(240, 100%, 79%, 0.196);
        --color-fourth-transparent-less: #6565ff67;
        --color-fourth: #6566FF;
        --color-fourth-darker: #5656ff;
        --color-fourth-darker-transparent-less: rgba(70, 70, 241, 0.575);
        --color-fifth: white;
        --color-fourth-transparent-accent: #6565ff52;

        --cl-fourth-light: #dbdbff;

        --zoom-bg-color: rgba(0, 0, 0, 0.3);
        --cl-main-disabled: #8d8d9b;
      }
    `;
    }
    else if (styleName == "green") {
        styleElement.innerHTML = `
      :root {
        --color-fourth-transparent: #478d0726;
        --color-fourth-transparent-less: #478d0778;
        --color-fourth: #478d07;
        --color-fourth-darker: #478d07;
        --color-fourth-darker-transparent-less: #31600575;
        --color-fifth: #9dbf7ec7;
        --color-fourth-transparent-accent: #478d0740;

        --cl-fourth-light: #e4e4e4;

        --zoom-bg-color: rgba(0, 0, 0, 0.3);
        --cl-main-disabled: #8d8d9b;
      }
    `;
    }
    switch (design) {
        case "smthl-material":
            const element = document.createElement("link");
            element.rel = "stylesheet";
            element.type = "text/css";
            element.href = "/assets/themes/smthl-material.css";
            console.time("theme loading time");
            element.onload = () => {
                console.timeEnd("theme loading time");
            };
            document.head.appendChild(element);
            break;
        default:
            break;
    }
    document.head.appendChild(styleElement);
};
